import type { Note } from "../types/note.ts";
import { getUserId } from "../utils/getUserId.ts";
import client from "../api_v2/client";

/**
 * Загружает заметки по ревизии
 */
export async function getNotes(since = 0): Promise<Note[]> {
  const userId = getUserId();
  if (!userId) throw new Error("User not logged in");

  const { data } = await client.get("/ruznama/get_notes.php", {
    params: { user_id: userId, since },
  });
  return data.result as Note[];
}

/**
 * Создаёт новую заметку
 */
export async function createNote(note: Omit<Note, "id">): Promise<Note> {
  const userId = getUserId();
  if (!userId) throw new Error("User not logged in");

  const payload = {
    ...note,
    user_id: userId,
    color_argb: note.color,
    labels: (note.labels ?? []).map((label: any) => Number(label.id ?? label)),
  };
  delete (payload as any).color;

  console.log("payload to server", payload);

  const { data } = await client.post("/ruznama/create_note.php", payload);

  if (!data.success) {
    throw new Error(data.error || "Failed to create note");
  }
  const { id, rev } = data;
  return { ...(note as Note), id, rev };
}

/**
 * Обновляет заметку
 */
export async function updateNote(note: Note): Promise<void> {
  const userId = getUserId();
  if (!userId) throw new Error("User not logged in");

  const payload = {
    ...note,
    user_id: userId,
    color_argb: note.color,
    labels: (note.labels ?? []).map((label: any) => Number(label.id ?? label)),
  };
  delete (payload as any).color;

  const { data } = await client.post("/ruznama/update_note.php", payload);
  if (!data.success) {
    throw new Error(data.error || "Failed to update note");
  }
}

/**
 * Удаляет заметку
 */
export async function deleteNote(id: number): Promise<void> {
  const userId = getUserId();
  if (!userId) throw new Error("User not logged in");

  await client.get("/ruznama/delete_note.php", { params: { id, user_id: userId } });
}
